/* The sort select in the collection toolbar mirrors into the (mobile) facet form. */
(function () {
    var toolbar = document.getElementById('SortBy-toolbar');
    if (!toolbar) return;
    toolbar.addEventListener('change', function () {
      var forms = ['FacetFiltersForm', 'FacetFiltersFormMobile'];
      for (var i = 0; i < forms.length; i++) {
        var form = document.getElementById(forms[i]);
        if (!form) continue;
        var sel = form.querySelector('select[name="sort_by"]');
        if (!sel) continue;
        sel.value = toolbar.value;
        sel.dispatchEvent(new Event('input', { bubbles: true }));
        return;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', toolbar.value);
      window.location.href = url.toString();
    });
  })();
